// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"06377e61-168":"f2b36bf05468edd2e2e3","06377e61-794":"71d4d2d3768844f106dd","06377e61-735":"a8f8eccbdaba6b13faae","06377e61-91":"b08bbb9cec1b9da1900d"}[chunkId] + ".js";
};